import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

/**
 * useSharedEvents
 *
 * Events the current user has accepted invites to compliance-review. Powers
 * the "Shared with me" events tab on HomePage. Mirrors `useSharedCampaigns`.
 */
export function useSharedEvents() {
  const { user } = useAuth();
  const queryKey = user?.id ? ['sharedEvents', user.id] : ['sharedEvents', 'anonymous'];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const { data } = await api.get('/api/event-reviews/events');
      return Array.isArray(data) ? data : [];
    },
    enabled: !!user?.id,
    staleTime: 60 * 1000,
    retry: 1,
  });
}
